import { createActions } from 'redux-actions'

export const {
  getFrontendSettingRequest,
  getFrontendSettingSucceed,
  updateFrontendSettingRequest,
  updateFrontendSettingSucceed,
  requestFailure
} = createActions(
  {
    GET_FRONTEND_SETTING_REQUEST: undefined,
    GET_FRONTEND_SETTING_SUCCEED: (frontendSetting) => frontendSetting,
    UPDATE_FRONTEND_SETTING_REQUEST: (frontendSetting) => frontendSetting,
    UPDATE_FRONTEND_SETTING_SUCCEED: (frontendSetting) => frontendSetting,
    REQUEST_FAILURE: (err) => err
  },
  { prefix: 'SETTING' }
)
